import { Link } from 'react-router-dom';

export default function UserFooter() {
   return (
      <nav className="flex justify-center w-full shadow-sm text-gray-600 bg-gray-200 p-3 border-t border-gray-300">
         <a href="/privacy-policy.pdf" target="_blank">
            Privacy Notice
         </a>
      </nav>
   );
}
